<template>
  <v-alert
    v-if="visible && $vuetify.breakpoint.smAndDown"
    elevation="0"
    rounded="lg"
    dark
    class="py-2 px-2"
  >
    <div class="d-flex align-center justify-space-between app-promo-alert-row">
      <div class="d-flex align-center">
        <div class="d-flex align-center">
          <v-btn
            icon
            @click="closeAlert"
            class="mr-1"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="d-flex flex-column">
          <span class="text-body-1 font-weight-bold">
            {{ $t("app_promotion_alert.title") }}
          </span>
          <span class="text-caption">
            {{ $t("app_promotion_alert.description") }}
          </span>
        </div>
      </div>
      <div class="d-flex align-center">
        <v-btn dense light class="px-2 text-body-1 font-weight-bold text-capitalize" @click="openAppStore">{{ $t("Download") }}</v-btn>
      </div>
    </div>
  </v-alert>
</template>

<script>
export default {
  name: 'AppPromotionAlert',
  created() {
    if (
      localStorage.getItem('appPromoAlertShown')
      || this.isDesktop()
      || navigator.userAgent.includes('cordova-app')
      || navigator.userAgent.includes('cordova-app-ios')
    ) {
      this.visible = false;
    }
  },
  data() {
    return {
      visible: true,
    };
  },
  methods: {
    closeAlert() {
      this.visible = false;
      localStorage.setItem('appPromoAlertShown', 'true');
    },
    openAppStore() {
      window.open(
        (this.isIOS() && !this.isDesktop())
          ? this.$store.state.appDownloadLinks.ios
          : this.$store.state.appDownloadLinks.android,
        '_blank',
      );
    },
    isIOS() {
      return (/iphone|ipod|ipad|cordova-app-ios/i.test(window.navigator.userAgent));
    },
    isDesktop() {
      if (navigator.userAgentData && navigator.userAgentData.mobile) {
        return false;
      }
      return !/mobile|android|iphone|ipad|ipod|blackberry|iemobile|opera mini|cordova-app|cordova-app-ios/i.test(navigator.userAgent);
    },
  },
};
</script>

<style scoped>
.app-promo-alert-row {
  flex-wrap: nowrap !important;
}
</style>
